export default __webpack_public_path__ + "assets/media/0422577f4a52fe82d0702a83d1b23091.mp3";